import { ReferenceData } from './reference-data.model';

export class Location extends ReferenceData {

  rollsUpTo: { correlation: string };
  garageCode: string; // formerly scanEquipmentCode
  locationTypeId: { correlation: string }; // boardTypeId
  manpowerLocationId: string; // quotaCode
  hrmsLocationId: string; // hrmsLocationCode
  workUnitId: { correlation: string };
  servicedBy: { correlation: string }[];
  servicesSelf: boolean;
  legacyZone: string;

  // new for EIS
  bureau: { correlation: string };
  mainGarage: boolean;

  departmentInformations: {
    departmentId: { correlation: string };
    departmentTypeId: { correlation: string };
    sectionId: number;
    payCodeId: { correlation: string };
    budgetCode: string;
  }[];

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.rollsUpTo = data.rollsUpTo;
    this.garageCode = data.garageCode; // formerly scanEquipmentCode
    this.locationTypeId = data.locationTypeId;
    this.manpowerLocationId = data.manpowerLocationId; // quotaCode
    this.hrmsLocationId = data.hrmsLocationId; // hrmsLocationCode
    this.workUnitId = data.workUnitId;
    this.servicedBy = data.servicedBy;
    this.servicesSelf = data.servicesSelf;
    this.legacyZone = data.legacyZone;

    this.bureau = data.bureau;
    this.mainGarage = data.mainGarage;

    this.departmentInformations = data.departmentInformations;
  }
}
